import { useContext, useState } from "react";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import ModalTambahTandaTerima from "../components/ModalTambahTandaTerima";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import { formatDate } from "../../../Utils/externalFunctions";
import ModalDeleteTandaTerima from "../components/ModalDeleteTandaTerima";
import ModalDetailTandaTerima from "../components/ModalDetailTandaTerima";
import {
  PERMISSIONS,
} from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useTandaTerima } from "../../../Context/TandaTerimaContext";

const TandaTerimaColumns = (refreshTandaTerima) => {
  const tandaTerimaAPI = useTandaTerima();
  const username = localStorage.getItem("username");
  const { checkPermission } = useContext(RoleContext);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [updateOpen, setUpdateOpen] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [detailOpen, setDetailOpen] = useState(null);

  const toggleDropdown = (id) =>
    setDropdownOpen(dropdownOpen === id ? null : id);
  const toggleUpdate = (id) => setUpdateOpen(updateOpen === id ? null : id);
  const toggleDelete = (id) => setDeleteOpen(deleteOpen === id ? null : id);
  const toggleDetail = (id) => setDetailOpen(detailOpen === id ? null : id);

  const cetakTandaTerima = (id) => {
    tandaTerimaAPI.getTandaTerimaCetak(id, () => toggleDropdown(id));
  };

  return [
    {
      name: <DataTableTitle text={"ID"} />,
      selector: (row) => row.id_tanda_terima,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Nomor Surat"} />,
      selector: (row) => row.nomor_surat,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Perihal"} />,
      cell: (row) => (
        <>
          <a
            href="#"
            onClick={(e) => {
              toggleDetail(row.id_tanda_terima);
              e.preventDefault();
            }}
          >
            {row.perihal}
          </a>
          <ModalDetailTandaTerima
            data={row}
            toggle={() => toggleDetail(row.id_tanda_terima)}
            isOpen={detailOpen === row.id_tanda_terima}
          />
        </>
      ),
    },
    {
      name: <DataTableTitle text={"Dibuat Oleh"} />,
      selector: (row) => row.created_by,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Divisi"} />,
      selector: (row) => row.unit_kerja_nama,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Waktu Dibuat"} />,
      selector: (row) => formatDate(row.waktu_dibuat),
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Status"} />,
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Opsi"} />,
      cell: (row) => {
        return (
          <div>
            <Dropdown
              toggle={() => toggleDropdown(row.id_tanda_terima)}
              isOpen={dropdownOpen === row.id_tanda_terima}
            >
              <DropdownToggle>&#9660;</DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  style={{ color: "#000" }}
                  onClick={() => cetakTandaTerima(row.id_tanda_terima)}
                >
                  Cetak
                </DropdownItem>
                {row.created_by === username && (
                  <>
                    {checkPermission(PERMISSIONS.CHANGE_TANDA_TERIMA) && (
                        <DropdownItem
                          style={{ color: "#000" }}
                          onClick={() => toggleUpdate(row.id_tanda_terima)}
                        >
                          Edit
                        </DropdownItem>
                      )}
                    {checkPermission(PERMISSIONS.DELETE_TANDA_TERIMA) && (
                        <DropdownItem
                          style={{ color: "#000" }}
                          onClick={() => toggleDelete(row.id_tanda_terima)}
                        >
                          Delete
                        </DropdownItem>
                      )}
                  </>
                )}
              </DropdownMenu>
            </Dropdown>
            <>
              {row.created_by === username && (
                <>
                  <ModalTambahTandaTerima
                    create={false}
                    tandaTerima={row}
                    resetState={refreshTandaTerima}
                    toggle={toggleUpdate}
                    isOpen={row.id_tanda_terima === updateOpen}
                  />
                  <ModalDeleteTandaTerima
                    name={row.nomor_surat}
                    axiosDelete={tandaTerimaAPI.deleteTandaTerima}
                    pk={row.id_tanda_terima}
                    resetState={refreshTandaTerima}
                    toggle={toggleDelete}
                    isOpen={row.id_tanda_terima === deleteOpen}
                  />
                </>
              )}
            </>
          </div>
        );
      },
    },
  ];
};

export default TandaTerimaColumns;
